import { formatAUD, isNegative } from "@/lib/format";

export default function YoyStrip({ yoy, current, onPick }) {
  return (
    <div className="flex gap-3 overflow-x-auto pb-1" data-testid="cashflow-yoy-strip">
      {yoy.map((y) => (
        <button key={y.fy} type="button" onClick={() => onPick(y.fy)} data-testid={`cashflow-yoy-${y.fy}`}
          className={`min-w-[200px] text-left border p-4 transition-colors duration-150 ${
            y.fy === current ? "border-emerald-500/60 bg-emerald-500/5" : "border-border bg-card hover:bg-accent/40"
          }`}>
          <div className="font-mono text-xs text-muted-foreground">{y.fy}</div>
          <div className={`font-mono text-lg mt-1 ${isNegative(y.net) ? "text-rose-300" : "text-foreground"}`}>{formatAUD(y.net)}</div>
          <div className="font-mono text-[11px] text-muted-foreground mt-1">
            <span className="text-emerald-400">+{formatAUD(y.income)}</span> · <span className="text-rose-400">−{formatAUD(y.expenditure)}</span>
          </div>
        </button>
      ))}
    </div>
  );
}
